module.exports = __webpack_public_path__ + "static/media/pan_approved.3712017b.svg";